module.exports = __webpack_public_path__ + "logo.39259158bf6301757b25.jpg";


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/assets/images/logo.jpg
// module id = ../../../../../src/assets/images/logo.jpg
// module chunks = 2